module.exports = __webpack_public_path__ + "img/step-4.ffa735cf.svg";